import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetProjectExtensionRequestDetailsById = createAsyncThunk(
  "GetProjectExtensionRequestDetailsById/GetProjectExtensionRequestDetailsById",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ProjectExtensionRequestDetails/GetProjectExtensionRequestDetailsById",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteProjectExtensionRequestDetails = createAsyncThunk(
  "DeleteProjectExtensionRequestDetails/DeleteProjectExtensionRequestDetails",
  async (projectExtensionRequestDetailsId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ProjectExtensionRequestDetails/DeleteProjectExtensionRequestDetails",

        projectExtensionRequestDetailsId
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateProjectExtensionRequestDetails = createAsyncThunk(
  "UpdateProjectExtensionRequestDetails/UpdateProjectExtensionRequestDetails",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ProjectExtensionRequestDetails/UpdateProjectExtensionRequestDetails",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddProjectExtensionRequestDetails = createAsyncThunk(
  "AddProjectExtensionRequestDetails/AddProjectExtensionRequestDetails",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ProjectExtensionRequestDetails/AddProjectExtensionRequestDetails",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetListProjectExtensionRequestDetails = createAsyncThunk(
  "GetListProjectExtensionRequestDetails/GetListProjectExtensionRequestDetails",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ProjectExtensionRequestDetails/GetListProjectExtensionRequestDetails",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data,"data");
      

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ProjectExtensionRequestDetails = createSlice({
  name: "ProjectExtensionRequestDetails",
  initialState: {
    ProjectExtensionRequestDetails: {},
    loadingProjectExtensionRequestDetails: false,
    errorProjectExtensionRequestDetails: null,

    AddProjectExtensionRequestDetails: {},
    loadingAddProjectExtensionRequestDetails: false,
    errorAddProjectExtensionRequestDetails: null,

    UpdateProjectExtensionRequestDetails: {},
    loadingUpdateProjectExtensionRequestDetails: false,
    errorUpdateProjectExtensionRequestDetails: null,

    DeleteProjectExtensionRequestDetails: {},
    loadingDeleteProjectExtensionRequestDetails: false,
    errorDeleteProjectExtensionRequestDetails: null,



    GetListProjectExtensionRequestDetails: [],
    loadingGetListProjectExtensionRequestDetails: false,
    errorGetListProjectExtensionRequestDetails: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(
        GetProjectExtensionRequestDetailsById.pending,
        (state, action) => {
          state.loadingProjectExtensionRequestDetails = true;
          state.ProjectExtensionRequestDetails = action.payload;
          state.errorProjectExtensionRequestDetails = null;
        }
      )
      .addCase(
        GetProjectExtensionRequestDetailsById.fulfilled,
        (state, action) => {
          state.loadingProjectExtensionRequestDetails = false;
          state.ProjectExtensionRequestDetails = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetProjectExtensionRequestDetailsById.rejected,
        (state, action) => {
          state.loadingProjectExtensionRequestDetails = false;
          state.errorProjectExtensionRequestDetails = action.payload;
        }
      )

      .addCase(
        DeleteProjectExtensionRequestDetails.pending,
        (state, action) => {
          state.loadingProjectExtensionRequestDetails = true;
          state.DeleteProjectExtensionRequestDetails = action.payload;
          state.errorProjectExtensionRequestDetails = null;
        }
      )
      .addCase(
        DeleteProjectExtensionRequestDetails.fulfilled,
        (state, action) => {
          state.loadingProjectExtensionRequestDetails = false;
          state.DeleteProjectExtensionRequestDetails = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        DeleteProjectExtensionRequestDetails.rejected,
        (state, action) => {
          state.loadingProjectExtensionRequestDetails = false;
          state.errorDeleteProjectExtensionRequestDetails = action.payload;
        }
      )

      .addCase(
        UpdateProjectExtensionRequestDetails.pending,
        (state, action) => {
          state.loadingUpdateProjectExtensionRequestDetails = true;
          state.UpdateProjectExtensionRequestDetails = action.payload;
          state.errorUpdateProjectExtensionRequestDetails = null;
        }
      )
      .addCase(
        UpdateProjectExtensionRequestDetails.fulfilled,
        (state, action) => {
          state.loadingUpdateProjectExtensionRequestDetails = false;
          state.ProjectExtensionRequestDetails = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        UpdateProjectExtensionRequestDetails.rejected,
        (state, action) => {
          state.loadingUpdateProjectExtensionRequestDetails = false;
          state.errorUpdateProjectExtensionRequestDetails = action.payload;
        }
      )

      .addCase(AddProjectExtensionRequestDetails.pending, (state, action) => {
        state.loadingProjectExtensionRequestDetails = true;
        state.AddProjectExtensionRequestDetails = action.payload;
        state.errorAddProjectExtensionRequestDetails = null;
      })
      .addCase(AddProjectExtensionRequestDetails.fulfilled, (state, action) => {
        state.loadingAddProjectExtensionRequestDetails = false;
        state.AddProjectExtensionRequestDetails = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddProjectExtensionRequestDetails.rejected, (state, action) => {
        state.loadingAddProjectExtensionRequestDetails = false;
        state.errorAddProjectExtensionRequestDetails = action.payload;
      })
      .addCase(
        GetListProjectExtensionRequestDetails.pending,
        (state, action) => {
          state.loadingGetListProjectExtensionRequestDetails = true;
          state.GetListProjectExtensionRequestDetails = action.payload;
          state.errorGetListProjectExtensionRequestDetails = null;
        }
      )
      .addCase(
        GetListProjectExtensionRequestDetails.fulfilled,
        (state, action) => {
          state.loadingGetListProjectExtensionRequestDetails = false;
          state.GetListProjectExtensionRequestDetails = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetListProjectExtensionRequestDetails.rejected,
        (state, action) => {
          state.loadingGetListProjectExtensionRequestDetails = false;
          state.errorGetListProjectExtensionRequestDetails = action.payload;
        }
      );
  },
});

export default ProjectExtensionRequestDetails.reducer;
